import {
  UserGroup,
  Inbox2,
  User,
  CheckSquare,
  FileText,
  Folder,
  Trash,
  MailWarning,
  CalendarClock,
  MailOpen,
  Pin,
} from '@groovehq/internal-design-system/lib/assets/icons'
import { FOLDER_KIND_DRAFT } from 'ducks/folders/constants'

export default function FolderKindIcon({ kind, ...restProps }) {
  if (kind === 'unassigned') {
    return <Inbox2 {...restProps} />
  } else if (kind === 'mine') {
    return <User {...restProps} />
  } else if (kind === 'closed') {
    return <CheckSquare {...restProps} />
  } else if (kind === FOLDER_KIND_DRAFT) {
    return <FileText {...restProps} />
  } else if (kind === 'assigned') {
    return <UserGroup {...restProps} />
  } else if (kind === 'trash') {
    return <Trash {...restProps} />
  } else if (kind === 'spam') {
    return <MailWarning {...restProps} />
  } else if (kind === 'snoozed') {
    return <CalendarClock {...restProps} />
  } else if (kind === 'open') {
    return <MailOpen {...restProps} />
  } else if (kind === 'pin') {
    return <Pin {...restProps} />
  }

  return <Folder {...restProps} />
}
